<template>
  <combobox
    :disabled="disabled"
    :errors="internalErrors"
    :internal-search="false"
    :is-loading="isLoading"
    :label="label"
    :multiple="multiple"
    :options="options"
    :placeholder="placeholder"
    :value="internalValue"
    @close="onClose"
    @input="onInput"
    @search="onSearch"
    class="product-category-combobox"
    ref="primaryInput"
  >
    <template scope="props" slot="option">
      <product-category-hierarchy :category="props.option" v-if="props.option" />
    </template>

    <template slot="singleLabel">
      <product-category-hierarchy :category="internalValue" slot="singleLabel" />
    </template>
  </combobox>
</template>

<script>
import productCategoriesQuery
  from '@/api/queries/product-categories-with-ancestors.graphql';
import ProductCategoryHierarchy from '@/components/ProductCategoryHierarchy';
import ResourceCombobox from '@/mixins/ResourceCombobox';

export default {
  name: 'product-category-combobox',
  mixins: [
    ResourceCombobox({
      searchQuery: productCategoriesQuery,
      unfilteredSort: { field: 'UPDATED_AT', direction: 'DESC' },
    }),
  ],
  components: {
    ProductCategoryHierarchy,
  },
};
</script>

<style scoped lang="scss">
.product-category-combobox__ancestor,
.product-category-combobox__name {
  display: block;
  float: left;
}

.product-category-combobox__ancestor {
  margin-right: 3px;
  opacity: 0.6;
}

.product-category-combobox__name:after {
  clear: both;
}
</style>



// WEBPACK FOOTER //
// ProductCategoryCombobox.vue?dbfdedea